import { Loader2, Sparkles, AlertTriangle } from "lucide-react";

export const ResultError = ({ result, testid }) => (
  <div className="border border-red-400/40 bg-red-400/5 px-4 py-3 flex items-start gap-2" data-testid={testid}>
    <AlertTriangle size={14} className="text-red-400 mt-0.5 shrink-0" />
    <div>
      <div className="font-mono text-[11px] uppercase tracking-widest text-red-400 mb-1">
        Error{result.status ? ` · ${result.status}` : ""}
      </div>
      <div className="text-sm text-white">{result.error}</div>
    </div>
  </div>
);

export const ResultOk = ({ label, testid, children }) => (
  <div className="border border-[#00ff41]/40 bg-[#00ff41]/5 px-4 py-3" data-testid={testid}>
    <div className="font-mono text-[11px] uppercase tracking-widest text-[#00ff41] mb-1">{label}</div>
    {children}
  </div>
);

/** Bordered admin action row: title + description + run button, results below. */
export const ActionCard = ({ title, description, busy, busyLabel, idleLabel, onRun, runTestId, cardTestId, children }) => (
  <div className="border border-[#3a3a3a] bg-[#121212] p-5" data-testid={cardTestId}>
    <div className="flex items-start justify-between gap-4 mb-3">
      <div>
        <h2 className="font-display font-bold text-lg mb-1">{title}</h2>
        <p className="text-sm text-[#e2e2e2] max-w-md">{description}</p>
      </div>
      <button
        type="button"
        onClick={onRun}
        disabled={busy}
        data-testid={runTestId}
        className="shrink-0 border border-[#cfff04] text-[#cfff04] hover:bg-[#cfff04] hover:text-[#050505] px-5 py-2 font-mono text-xs uppercase tracking-widest disabled:opacity-40 transition-colors flex items-center gap-2"
      >
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />}
        {busy ? busyLabel : idleLabel}
      </button>
    </div>
    {children}
  </div>
);
